import React from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row } from 'reactstrap';
import { Title } from '../Shared';
import { FindLocation } from './';

function Home(props) {
  const { history } = props;

  return (
    <div
      style={{ flex: 1, backgroundColor: '#F2F2F2', minHeight: `calc(100vh)` }}
    >
      <div
        style={{
          borderBottomRightRadius: 50,
          borderBottomLeftRadius: 50,
          backgroundColor: '#FFF',
        }}
      >
        <Title text={'Welcome to Park Warrior'} />
        <Container className="px-4" style={{ paddingTop: 100 }}>
          <Col className="align-self-center">
            <Row className="text-center">
              <p className="orange-title">
                Welcome to <br /> Park Warrior.
              </p>
            </Row>
          </Col>
        </Container>

        <Container className="pt-2 pb-5 px-4" fluid>
          <FindLocation history={history} />
        </Container>
      </div>
    </div>
  );
}

const connectedHome = connect()(Home);
export { connectedHome as Home };
